import React, { Component } from 'react'
import styled from 'styled-components'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import { TweenMax } from 'gsap'
import StarIconDark from '@/assets/images/star-icon-dark.svg'
import StarIconDarkQ from '@/assets/images/star-icon-dark-q.svg'
import { range, vhToPx } from '@/utils'

@inject('AutomationStore', 'GameStore')
@observer
export default class DDStar extends Component {
  constructor(props) {
    super(props)
    extendObservable(this, {
      selectedStar: 0,
      dropDownValues: null,
      currencyFixed: false,
    })
    this.preset = null
    this.has_mult =
      this.props.item.type.toLowerCase().indexOf('liveplay') === 0 ||
      this.props.item.type.toLowerCase().indexOf('gamemaster') === 0

    this.hasDropDown = null
    this.dropdownStarSelectId = ''
    this.dropdownStarOptionIdNone = ''
    this.dropdownStarOptionIdSingle = ''
  }

  initOptionEventListener(mode) {
    let func = evt => {
      const option = this[`star-option-base-${this.props.index}`]

      if (option) {
        let targetElement = evt.target // clicked element

        do {
          if (targetElement == option) {
            // This is a click inside. Do nothing, just return.
            return
          }
          // Go up the DOM
          targetElement = targetElement.parentNode
        } while (targetElement)

        // This is a click outside.
        if (option.classList.contains('open')) {
          option.className = option.className.replace(' open', '')
          TweenMax.to(option, 0.3, { visibility: 'hidden' })
        }
        document.removeEventListener('click', func)
      }
    }

    if (mode === 0) {
      document.removeEventListener('click', func)
    } else {
      document.addEventListener('click', func)
    }
  }

  handleStarClick(refId) {
    if (this.props.automationAddEvent) {
      this.props.automationAddEvent({ evt: 'click', refId: refId, wait: 0.5 })
    }

    const option = this[`star-option-base-${this.props.index}`]
    if (option) {
      if (option.classList.contains('open')) {
        this.initOptionEventListener(0)
        option.className = option.className.replace(' open', '')
        TweenMax.to(option, 0.3, { visibility: 'hidden', zIndex: -1000 })
      } else {
        setTimeout(() => {
          this.initOptionEventListener(1)
          option.className += ' open'
          TweenMax.to(option, 0.3, { visibility: 'visible', zIndex: 1000 })
        }, 0)
      }
    }
  }

  handleOptionItemClick(multiplier, refId) {
    if (this.props.automationAddEvent) {
      this.props.automationAddEvent({ evt: 'click', refId: refId, wait: 0.5 })
    }

    this.selectedStar = multiplier
    this.props.value(multiplier)

    const option = this[`star-option-base-${this.props.index}`]
    if (option) {
      if (option.classList.contains('open')) {
        this.initOptionEventListener(0)
        option.className = option.className.replace(' open', '')
        TweenMax.to(option, 0.3, { visibility: 'hidden', zIndex: -1000 })
      }
    }
  }

  handleSingle(refId) {
    if (this.props.automationAddEvent) {
      this.props.automationAddEvent({
        evt: 'click',
        refId: this.dropdownStarSelectId,
        wait: 0.5,
        doNotSave: true,
      })
      this.props.automationAddEvent({ evt: 'click', refId: refId, wait: 0.5 })
    }

    const single = this[`star-single-${this.props.index}`]
    if (single) {
      if (this.selectedStar && this.isSet()) {
        TweenMax.set(single, { opacity: 0.2, filter: 'grayscale(1)' })
        this.selectedStar = 0
        this.props.value(0)
      } else {
        TweenMax.set(single, { opacity: 1, filter: 'grayscale(0)' })
        this.selectedStar = 1
        this.props.value(1)
      }
    }
  }

  initPreset(doInitStarValue, item = this.props.item) {
    if (item && item.preset && item.preset.awards && item.preset.awards.stars) {
      this.preset = item.preset.awards.stars
    }

    if (
      !this.preset &&
      this.props.GameStore &&
      this.props.GameStore.sportType
    ) {
      const { awards } = this.props.GameStore.sportType
      if (item && awards && awards[(item.type || '').toLowerCase()]) {
        let filteredAwards = awards[(item.type || '').toLowerCase()]
        if (filteredAwards && filteredAwards.stars) {
          this.preset = filteredAwards.stars
        }
      }
    }

    if (this.preset) {
      this.currencyFixed =
        this.has_mult && this.preset.m && this.preset.m === 'f'
      this.hasDropDown =
        this.preset.values ||
        (this.preset.range && this.preset.range[1] > 1) ||
        (this.preset.m && this.preset.m !== 'f')
      if (this.hasDropDown)
        this.dropDownValues = this.preset.values || range(...this.preset.range)
      if (doInitStarValue) {
        this.selectedStar = this.preset ? this.preset.v : 0
        if (this.props.value && typeof this.props.value === 'function') {
          this.props.value(this.preset.v === undefined ? null : this.preset.v)
          this.props.value(null, 'stars', this.currencyFixed)
        }
      }
    }
  }

  isSet() {
    return !(
      this.props.item.stars === undefined || this.props.item.stars === null
    )
  }

  componentWillMount() {
    this.initPreset(!this.isSet())
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item) {
      this.initPreset(false, nextProps.item)
      if (nextProps.item.stars !== this.props.item.stars) {
        this.selectedStar = nextProps.item.stars
        const single = this[`star-single-${this.props.index}`]
        if (single) {
          TweenMax.set(single, {
            opacity: nextProps.item.stars ? 1 : 0.2,
            filter: 'grayscale(' + (nextProps.item.stars ? 0 : 1) + ')',
          })
        }
      }
      if (
        this.has_mult &&
        nextProps.item.hasOwnProperty('currencyFixed') &&
        nextProps.item.currencyFixed !== this.props.item.currencyFixed
      ) {
        this.currencyFixed =
          nextProps.item.currencyFixed &&
          nextProps.item.currencyFixed.indexOf('s') !== -1
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.initStarVal && !prevProps.initStarVal) {
      this.initPreset(true)
    }
  }

  componentDidMount() {
    let { item } = this.props

    if (item) {
      if (item.type) {
        if (item.id) {
          this.dropdownStarSelectId = `dropdown-star-select-${item.type}-${item.id}`
          this.dropdownStarOptionIdNone = `dropdown-star-option-${item.type}-${item.id}-0`
          this.dropdownStarOptionIdSingle = `dropdown-star-option-${item.type}-${item.id}-1`
        } else {
          this.dropdownStarSelectId = `dropdown-star-select-${item.type}-${this.props.AutomationStore.playSequence}`
          this.dropdownStarOptionIdNone = `dropdown-star-option-${item.type}-${this.props.AutomationStore.playSequence}-0`
          this.dropdownStarOptionIdSingle = `dropdown-star-option-${item.type}-${this.props.AutomationStore.playSequence}-1`
        }
      } else {
        this.dropdownStarSelectId = `dropdown-star-select-${this.props.AutomationStore.playSequence}`
        this.dropdownStarOptionIdNone = `dropdown-star-option-${this.props.AutomationStore.playSequence}-0`
        this.dropdownStarOptionIdSingle = `dropdown-star-option-${this.props.AutomationStore.playSequence}-1`
      }
    }

    if (this.has_mult && item.hasOwnProperty('currencyFixed'))
      this.currencyFixed =
        item.currencyFixed && item.currencyFixed.indexOf('s') !== -1
    if (item.stars !== undefined && item.stars !== null) {
      this.selectedStar = item.stars
    }

    const single = this[`star-single-${this.props.index}`]
    if (single)
      TweenMax.set(single, {
        opacity: this.selectedStar ? 1 : 0.2,
        filter: 'grayscale(' + (this.selectedStar ? 0 : 1) + ')',
      })
  }

  displayCurrentValue() {
    if (!this.selectedStar) return ''
    if (this.selectedStar > 1) {
      return `${this.preset.m && !this.currencyFixed ? 'x' : ''}${
        this.selectedStar
      }`
    } else {
      return `${
        this.preset.m && !this.currencyFixed ? 'x' + this.selectedStar : ''
      }`
    }
  }

  handleMultFixedToggle() {
    if (!this.has_mult) return
    this.currencyFixed = !this.currencyFixed
    this.props.value(null, 'stars', this.currencyFixed)
  }

  displayMultOrFixed() {
    if (!this.has_mult || !this.preset.m || this.preset.m !== 'o') return ''
    return (
      <OptionItem height={this.props.height}>
        <MultFixedSwitch
          onClick={this.handleMultFixedToggle.bind(this)}
          off={this.currencyFixed}
          title="Number of stars is multiplied by Fee Multiplier, or is fixed"
        >
          X
        </MultFixedSwitch>
      </OptionItem>
    )
  }

  render() {
    let { item, locked } = this.props
    if (this.hasDropDown) {
      return (
        <Scrolling>
          <StarButton
            id={this.dropdownStarSelectId}
            locked={locked}
            isset={
              this.isSet() || !this.props.from || this.props.from !== 'PlayItem'
                ? 1
                : ''
            }
            title={
              this.isSet() || !this.props.from || this.props.from !== 'PlayItem'
                ? ''
                : 'Selection Required'
            }
            height={this.props.height}
            innerRef={ref => (this[`star-selected-${this.props.index}`] = ref)}
            multiplier={this.selectedStar}
            onClick={
              locked
                ? null
                : this.handleStarClick.bind(this, this.dropdownStarSelectId)
            }
          >
            {this.displayCurrentValue()}
          </StarButton>
          <Option>
            <OptionItems
              innerRef={ref =>
                (this[`star-option-base-${this.props.index}`] = ref)
              }
            >
              {this.dropDownValues.map(i => {
                const _mult = i && this.preset.m && !this.currencyFixed
                const label = _mult ? i + 'x' : i
                let dropdownStarOptionId = ''
                if (item) {
                  if (item.type) {
                    if (item.id) {
                      dropdownStarOptionId = `dropdown-star-option-${item.type}-${item.id}-${i}`
                    } else {
                      dropdownStarOptionId = `dropdown-star-option-${item.type}-${this.props.AutomationStore.playSequence}-${i}`
                    }
                  } else {
                    dropdownStarOptionId = `dropdown-star-option-${this.props.AutomationStore.playSequence}-${i}`
                  }
                }

                return (
                  <OptionItem
                    id={dropdownStarOptionId}
                    key={i}
                    height={this.props.height}
                    innerRef={ref =>
                      (this[`star-option-${this.props.index}-${i}`] = ref)
                    }
                    isset={this.isSet()}
                    onClick={this.handleOptionItemClick.bind(
                      this,
                      i,
                      dropdownStarOptionId
                    )}
                    title={`${
                      _mult ? 'multiplied by user fee multiplier selection' : ''
                    }`}
                  >
                    {label}
                  </OptionItem>
                )
              })}
              {this.displayMultOrFixed()}
            </OptionItems>
          </Option>
        </Scrolling>
      )
    } else {
      return (
        <Scrolling>
          <StarButtonSingle
            id={this.dropdownStarOptionIdSingle}
            className="dd-star-single"
            isset={
              this.isSet() || !this.props.from || this.props.from !== 'PlayItem'
                ? 1
                : ''
            }
            title={
              this.isSet() || !this.props.from || this.props.from !== 'PlayItem'
                ? ''
                : 'Selection Required'
            }
            locked={locked}
            height={this.props.height}
            innerRef={ref => (this[`star-single-${this.props.index}`] = ref)}
            onClick={
              locked
                ? null
                : this.handleSingle.bind(this, this.dropdownStarOptionIdSingle)
            }
          />
        </Scrolling>
      )
    }
  }
}

const MultFixedSwitch = styled.span`
  cursor: pointer;
  font-weight: bold;
  color: ${props => (props.off ? '#ddd' : '#000')};
`

const Scrolling = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
`

const StarButton = styled.div`
  // width: ${props => props.height}vh;
  height: ${props => props.height}vh;
  background-color: ${props => (props.isset ? '#efdf17' : '#fff')};
  -webkit-filter: grayscale(
    ${props => (props.isset && !props.multiplier ? 1 : 0)}
  );
  opacity: ${props => (props.isset && !props.multiplier ? 0.2 : 1)};
  background-image: url(${props =>
    props.isset ? StarIconDark : StarIconDarkQ});
  background-repeat: no-repeat;
  background-size: 75%;
  background-position: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => 0.4 * props.height}vh;
  color: #ffffff;
`

const Option = styled.div`
  width: inherit;
`

const OptionItems = styled.div`
  width: inherit;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  visibility: hidden;
  position: absolute;
  border: ${props => 0.1}vh solid #1e90ff;
  z-index: 1000 !important;
`

const OptionItem = styled.div`
  width: auto;
  height: auto;
  min-height: ${props => props.height}vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => 0.5 * props.height}vh;
  color: #000000;
  &:hover {
    background-color: #efdf17;
  }
`

const StarButtonSingle = styled.div`
  // width: ${props => props.height}vh;
  height: ${props => props.height}vh;
  background-color: ${props => (props.isset ? '#efdf17' : '#fff')};
  -webkit-filter: grayscale(${props => (props.isset ? 1 : 0)});
  opacity: ${props => (props.isset ? 0.2 : 1)};
  background-image: url(${props =>
    props.isset ? StarIconDark : StarIconDarkQ});
  background-repeat: no-repeat;
  background-size: 75%;
  background-position: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => 0.4 * props.height}vh;
  color: #ffffff;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/Common/DDStar.js